<template>
  <b-modal v-model="modalVisible" centered hideHeaderClose hide-footer title="新增酒桶">
    <template #default="{ close }">
      <div>
        <b-form-group>
          <b-form-input v-model="content.kid" placeholder="ID" trim></b-form-input>
        </b-form-group>

        <b-form-group label="建立時狀態">
          <b-form-radio v-model="content.isReused" :value="false">新品</b-form-radio>
          <b-form-radio v-model="content.isReused" :value="true">再利用</b-form-radio>
        </b-form-group>

        <b-form-group label="尺寸">
          <b-form-radio v-model="content.sizeModel" value="30L">30L</b-form-radio>
          <b-form-radio v-model="content.sizeModel" value="20L">20L</b-form-radio>
          <b-form-radio v-model="content.sizeModel" value="10L">10L</b-form-radio>
        </b-form-group>

        <hr/>
      
        <div class="row justify-content-end">
          <div class="col-auto">
            <b-button @click="close">取消</b-button>
          </div>

          <div class="col-auto">
            <b-button @click="createBtnClicked" variant="primary">新增</b-button>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import commonBusyAndErrorHandling from "@/assets/js/commonBusyAndErrorHandling";
export default {
  mixins: [commonBusyAndErrorHandling],
  name: 'KegCreateSingleModal',
  data() {
    return {
      content: {
        kid: '',
        sizeModel: '',
        isReused: false,
      },
    };
  },
  components: {
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
      passed: false,
    },
  },
  computed: {
    modalVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },

  },
  watch: {
    modalVisible(val) {
      if (val) {
        this.reset();
      }
    }
  },
  mounted() {
  },
  methods: {
    reset() {
      this.content.kid = '';
      this.content.sizeModel = '30L';
      this.content.isReused = false;
    },
    async createBtnClicked() {
      try {
        await this.handleAsyncTask(() => this.$store.dispatch('keg/createKegs', [this.content]));
        alert('建立成功');
        this.modalVisible = false;
      } catch (error) {
        alert(error);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

</style>
